export const theme = {
  colors: {
    black: '#000',
    text: '#000',
    textHover: '#fff',
    background: '#fff',
    backdrop: 'rgba(0, 0, 0, 0.8)',
    primary: '#07c',
    secondary: '#05a',
    accent: '#609',
    muted: '#ccc',
    lightMuted: '#ededed',
  },
  space: [0, 2, 4, 8, 16, 32, 64, 128, 256, 512],
  fonts: {
    body: 'Roboto, Oxygen, sans-serif',
    heading: 'Roboto, Oxygen, sans-serif',
    monospace: 'Menlo, monospace',
  },
  fontSizes: {
    xs: 12,
    s: 14,
    m: 16,
    l: 32,
    xl: 64,
  },
  fontWeights: {
    normal: 400,
    bold: 700,
  },
  lineHeights: {
    body: 1.5,
    heading: 1.125,
  },
  borders: {
    none: 'none',
    normal: '1px solid #ccc',
  },
  radii: {
    none: '0',
    small: '2px',
    normal: '4px',
    big: '8px',
    round: '50%',
  },
};
